var map = {
	"./Canva_icon_15x15.svg": "07bd",
	"./Chargebee.svg": "4a30",
	"./Freshdesk.svg": "8f76",
	"./Infinity-loop-icon.svg": "cdb3",
	"./Xero.svg": "f80c",
	"./account-active.svg": "cf55",
	"./account-inactive.svg": "6c4c",
	"./active-slide-template-active.svg": "cbf3",
	"./active-slide-template.svg": "a9d2",
	"./add-bg.svg": "38df",
	"./add-icon-mini.svg": "140c",
	"./add-icon.svg": "71faa",
	"./add-ig-active.svg": "f115",
	"./add-ig-background.svg": "5c41",
	"./add-ig-img.svg": "2b8b",
	"./add-web-img.svg": "0c46",
	"./add.svg": "24e9",
	"./align-center-active.svg": "e991",
	"./align-center.svg": "d003",
	"./align-justify-active.svg": "5273",
	"./align-justify.svg": "e17c",
	"./align-left-active.svg": "f944",
	"./align-left.svg": "6b66",
	"./align-right-active.svg": "78d7",
	"./align-right.svg": "12c3",
	"./align-to-bottom-icon.svg": "0d17",
	"./align-to-left-icon.svg": "a867",
	"./align-to-middle-icon.svg": "4927",
	"./align-to-top-icon.svg": "1cec",
	"./big-cancel-icon.svg": "064b",
	"./calendar.svg": "d71f",
	"./campaign-account.svg": "1d10",
	"./campaign-delete-active.svg": "f716",
	"./campaign-delete.svg": "dc27",
	"./campaign-edit-active.svg": "93dc",
	"./campaign-edit.svg": "881c",
	"./campaign.svg": "d5c4",
	"./campaigns-active.svg": "13cd",
	"./campaigns-inactive.svg": "7a30",
	"./can-edit.svg": "7a98",
	"./cancel-icon.svg": "76b1",
	"./canva-icon.svg": "52ba",
	"./canva-list.svg": "7487",
	"./canva-listview-icon.svg": "1902",
	"./canva-mini-icon.svg": "278f",
	"./caret-bot.svg": "b500",
	"./caret-down.svg": "5a2a",
	"./checkbox-active.svg": "3ff0",
	"./checkbox-bg-checked.svg": "8f07",
	"./checkbox-bg.svg": "2a80",
	"./checkbox-default.svg": "ce68",
	"./checkbox-hover.svg": "594a",
	"./checked-all.svg": "9a6b",
	"./chevron-down.svg": "5d56",
	"./chevron-left.svg": "5397",
	"./chevron-right.svg": "4308",
	"./chevron-up-down.svg": "e00c",
	"./chevron-up.svg": "0480",
	"./clock-listview-icon.svg": "713d",
	"./clock.svg": "127c",
	"./close-folder.svg": "5b7c",
	"./close-red-icon.svg": "f6ae",
	"./close-x.svg": "6ea0",
	"./cloud-upload.svg": "cf99",
	"./config_loop.svg": "1602",
	"./copy-edit.svg": "bf09",
	"./cross-icon.svg": "6c73",
	"./custom-asset-icon-active.svg": "a48f",
	"./custom-asset-icon.svg": "ab37",
	"./custom-asset-list.svg": "d084",
	"./custom-asset-listview-icon.svg": "0273",
	"./custom-asset-mini-icon.svg": "8807",
	"./custom_asset.svg": "821f",
	"./dashboard-active.svg": "bb96",
	"./dashboard-inactive.svg": "9e3b",
	"./dashboard.svg": "0855",
	"./date-listview.svg": "973e",
	"./date.svg": "9bcd",
	"./delete-comfirm.svg": "b7e5",
	"./delete-ig.svg": "9287",
	"./delete.svg": "2c46",
	"./dj.svg": "97c5",
	"./dropbox-logo.svg": "9a04c",
	"./edit-camp-title.svg": "e054",
	"./edit-icon.svg": "9e92",
	"./edit-pen.svg": "8e26",
	"./edit.svg": "b0e3",
	"./email-account.svg": "d579",
	"./email-icon.svg": "7239",
	"./ethernet.svg": "0f61",
	"./exception-delete.svg": "ac4c",
	"./exception-edit.svg": "6537",
	"./fill-1.svg": "f64f",
	"./folder-account.svg": "9823",
	"./folder-active.svg": "e8b7",
	"./folder-organization.svg": "b100",
	"./folder-plus-active.svg": "9302",
	"./folder-plus.svg": "8bc9",
	"./folder-shared-active.svg": "0c89",
	"./folder-shared.svg": "6402",
	"./folder-tree.svg": "5da8",
	"./folder.svg": "756b",
	"./folder2.svg": "0e1f",
	"./get-screenshot.svg": "06d0",
	"./google-sheet-active.svg": "8984",
	"./google-sheet-icon.svg": "b98e",
	"./google-sheet-list.svg": "667f",
	"./google-sheet-listview-icon.svg": "e4e8",
	"./google-slide-active.svg": "ea7f",
	"./google-slide-icon.svg": "29f6",
	"./google-slide-list.svg": "82a6",
	"./google-slide-listview-icon.svg": "eb28",
	"./google_sheet.svg": "6f93",
	"./google_slide.svg": "3e1c",
	"./grid-layout-active.svg": "55ab",
	"./grid-layout.svg": "3ded",
	"./gridview-icon.svg": "2556",
	"./group-15.svg": "3cc0",
	"./home-folder-library.svg": "9109",
	"./home-icon.svg": "09be",
	"./ico-clone.svg": "b5df",
	"./icon-check.svg": "8821",
	"./icon-clone-active.svg": "f7b3",
	"./icon-clone-list.svg": "157d",
	"./icon-clone.svg": "4ce1",
	"./icon-trash.svg": "2d7f",
	"./ig-avatar.svg": "bc2a",
	"./ig-edit.svg": "163b",
	"./ig-editor-delete.svg": "316e",
	"./ig-header.svg": "9940",
	"./illus-smart-asset.svg": "9482",
	"./illus-upload.svg": "22b0",
	"./image-listview-icon.svg": "3662",
	"./image-mini-icon.svg": "3fc5",
	"./image.svg": "da27",
	"./instagram-add.svg": "1410",
	"./instagram-grid.svg": "f996",
	"./instagram-list-view-icon.svg": "5ccf",
	"./instagram-list.svg": "8f58",
	"./instagram-listview-icon.svg": "1b4b",
	"./instagram.svg": "d91d",
	"./justify-to-left-icon.svg": "6fc7",
	"./justify-to-middle-icon.svg": "b873",
	"./justify-to-right-icon.svg": "b8b8",
	"./landscape-default.svg": "db46",
	"./landscape-flipped.svg": "3d3e",
	"./landscape-icon-listview.svg": "0d9a",
	"./landscape-icon-note.svg": "4726",
	"./landscape-review.svg": "dd45",
	"./landscape.svg": "26f0",
	"./left-icon.svg": "1887",
	"./library-active.svg": "b72e",
	"./library-inactive.svg": "0546",
	"./library-rule.svg": "6701",
	"./list-layout-active.svg": "1650",
	"./list-layout.svg": "393c",
	"./listview-icon.svg": "2183",
	"./listview.svg": "16a3",
	"./logo-small.svg": "3e11",
	"./logo.svg": "e347",
	"./loop-account.svg": "5bed",
	"./loop-active.svg": "8318",
	"./loop-delete-active.svg": "a143",
	"./loop-delete-grid.svg": "8fa3",
	"./loop-delete-icon.svg": "bd19",
	"./loop-delete-list.svg": "5276",
	"./loop-edit-active.svg": "c66a",
	"./loop-edit-grid.svg": "3d08",
	"./loop-edit-icon.svg": "9aac",
	"./loop-edit-list.svg": "702c",
	"./loop-editor-active.svg": "6369",
	"./loop-editor.svg": "0ddb",
	"./loop-listview-icon.svg": "c426",
	"./loop-preview-active.svg": "1c88",
	"./loop-preview-grid.svg": "c38c",
	"./loop-preview-list.svg": "821e",
	"./loop-recycling.svg": "029b",
	"./loop-setting-active.svg": "0761",
	"./loop-setting-grid.svg": "3654",
	"./loop-setting-list.svg": "ec6e",
	"./loop-setting.svg": "8d0a",
	"./loop-settings-active.svg": "bcb3",
	"./loop.svg": "0eb8",
	"./loops-active.svg": "67ca7",
	"./loops-inactive.svg": "dcb2",
	"./loops-tree-folder.svg": "1ee0",
	"./loops-tree.svg": "fbae",
	"./loops.svg": "0b5c",
	"./magnifying-glass.svg": "ff6e",
	"./menu-mini.svg": "a959",
	"./menu.svg": "c8fa",
	"./menu/account.svg": "0d02",
	"./menu/admin.svg": "af5b",
	"./menu/campaign.svg": "b9a5",
	"./menu/help-link.svg": "3417",
	"./menu/library.svg": "fd02",
	"./menu/loops.svg": "bd0f",
	"./menu/overview.svg": "327f",
	"./menu/players.svg": "5728",
	"./menu/signout.svg": "d075",
	"./multiple-users-silhouette.svg": "d261",
	"./next.svg": "35fe",
	"./notification-blue.svg": "a308",
	"./notification-green.svg": "c789",
	"./notification-red.svg": "4ccd",
	"./notification-yellow.svg": "99f9",
	"./oppsite-arrow.svg": "4cbc",
	"./overview-campaign.svg": "6679",
	"./overview-folder.svg": "4117",
	"./overview-loop.svg": "3af7",
	"./overview-player-blue.svg": "2640",
	"./overview-player.svg": "137b",
	"./overview-tags.svg": "cb64",
	"./paging-next.svg": "497c",
	"./paging-prev.svg": "a4bd",
	"./password.svg": "e296",
	"./pdf-1.svg": "5670",
	"./pdf-active.svg": "0f6c",
	"./pdf-grid.svg": "14f6",
	"./pdf-icon.svg": "7a14",
	"./pdf-list.svg": "cc92",
	"./pdf-listview-icon.svg": "44d9",
	"./pdf.svg": "5fe9",
	"./pencil-edit.svg": "6a95",
	"./phone-account.svg": "d581",
	"./picture.svg": "34f5",
	"./player-account.svg": "d108",
	"./player-lancapse.svg": "0c9e",
	"./player-potrait.svg": "5694",
	"./players-active.svg": "5f65",
	"./players-inactive.svg": "0f15",
	"./playlist-editor.svg": "ada6",
	"./plus-campaign.svg": "3f46",
	"./plus-circle.svg": "d832",
	"./plus-folder.svg": "6851",
	"./plus.svg": "5860",
	"./pointing-right-active.svg": "87ac",
	"./pointing-right.svg": "0446",
	"./portrait-default.svg": "02f6",
	"./portrait-flipped.svg": "0e0d",
	"./portrait-icon-listview.svg": "b00c",
	"./portrait-icon-note-white.svg": "03e0",
	"./portrait-icon-note.svg": "4b47",
	"./portrait-review.svg": "3c9a",
	"./portrait.svg": "c1f6",
	"./preview-eye.svg": "fa92",
	"./preview_instagram.svg": "d81e",
	"./preview_loop.svg": "eea3",
	"./preview_loop_grid.svg": "a523",
	"./previous-white.svg": "b623",
	"./previous.svg": "21e7",
	"./radio-active.svg": "8332",
	"./radio-default.svg": "caf1b",
	"./radio-hover.svg": "c780",
	"./radio.svg": "924d",
	"./redo.svg": "901e",
	"./reload.svg": "4dab",
	"./reset.svg": "f709",
	"./right-icon.svg": "7833",
	"./role/account-role.svg": "a37f",
	"./role/employee-role.svg": "6398",
	"./role/folder-tree.svg": "cdfb",
	"./role/hardware-type-role.svg": "7835",
	"./role/language-role.svg": "5024",
	"./role/loops-tree.svg": "5a21",
	"./role/org-type-role.svg": "fdb2",
	"./role/organization-role.svg": "6882",
	"./role/overview-campaign.svg": "9039",
	"./role/overview-player.svg": "dea9",
	"./role/pi-firmware-role.svg": "65db",
	"./role/post-role.svg": "494b",
	"./role/role-role.svg": "e4d7",
	"./role/setting-role.svg": "a292",
	"./role/slide-template-role.svg": "bdb3",
	"./role/smart-asset-template-role.svg": "29f7",
	"./role/template-category-role.svg": "fdbc",
	"./role/term-role.svg": "1189",
	"./role/update-role.svg": "ecbf",
	"./role/user-role.svg": "dbac",
	"./sa-instagram.svg": "eace",
	"./sa-pdf.svg": "9368",
	"./sa-website.svg": "2cb9",
	"./save.svg": "c64f",
	"./screenfluence-loading.svg": "7aac0",
	"./search.svg": "22ee",
	"./secondary-icon-active.svg": "eb4f",
	"./secondary-icon.svg": "4ab5",
	"./selected-icon.svg": "bb77",
	"./seting-icon.svg": "a655",
	"./setting-icon.svg": "28c2",
	"./setting.svg": "6fdd",
	"./sf-search-icon.svg": "5518",
	"./share-edit-active.svg": "4cd5",
	"./share-edit-list.svg": "ef7c",
	"./share-edit.svg": "c133",
	"./share.svg": "c04a",
	"./shield.svg": "b324",
	"./size-litsview.svg": "f87f",
	"./smart-asset-calendar.svg": "3735",
	"./smart-asset-canvasux-icon.svg": "951b",
	"./smart-asset-clock.svg": "b03f",
	"./smart-asset-code.svg": "2f8c",
	"./smart-asset-facebook-icon.svg": "7421",
	"./smart-asset-facebook.svg": "0d47",
	"./smart-asset-googlesheets-icon.svg": "729c",
	"./smart-asset-instagram-active.svg": "1342",
	"./smart-asset-instagram-icon.svg": "d7d3",
	"./smart-asset-instagram.svg": "de65",
	"./smart-asset-pdf-icon.svg": "8a28",
	"./smart-asset-rss-icon.svg": "3bc1",
	"./smart-asset-rss.svg": "5cd7",
	"./smart-asset-sun.svg": "30f8",
	"./smart-asset-twitter-icon.svg": "49d1",
	"./smart-asset-twitter.svg": "c775",
	"./smart-asset-weather-icon.svg": "0083",
	"./smart-asset-website-active.svg": "a5cf",
	"./smart-asset-website-icon.svg": "dff8",
	"./smart-asset-website.svg": "d972",
	"./smart-asset-youtube.svg": "a0b8",
	"./smart-assets/001-sheets.svg": "9187",
	"./smart-assets/003-slides.svg": "3bff9",
	"./smart-assets/align-bottom-blue.svg": "6f45",
	"./smart-assets/align-bottom.svg": "cd81",
	"./smart-assets/align-center.svg": "e197",
	"./smart-assets/align-justify.svg": "0c58",
	"./smart-assets/align-left.svg": "aad5",
	"./smart-assets/align-middle-blue.svg": "6a20",
	"./smart-assets/align-middle.svg": "ee8c",
	"./smart-assets/align-right.svg": "a1d3",
	"./smart-assets/align-top-blue.svg": "c073",
	"./smart-assets/align-top.svg": "865f",
	"./smart-assets/bell notification.svg": "12b0",
	"./smart-assets/bg-img-icon.svg": "a5b7",
	"./smart-assets/browser-page-layout.svg": "0b84",
	"./smart-assets/canva-icon.svg": "7431",
	"./smart-assets/character-spacing.svg": "58e9",
	"./smart-assets/checkbox-active.svg": "8f43",
	"./smart-assets/chevron-down.svg": "f6dd",
	"./smart-assets/chevron-right.svg": "e29f",
	"./smart-assets/chevron-up.svg": "8b51",
	"./smart-assets/clone.svg": "53bb",
	"./smart-assets/close-x.svg": "ec07",
	"./smart-assets/color-palette.svg": "2a64",
	"./smart-assets/crop.svg": "0cea",
	"./smart-assets/delete-source.svg": "c897",
	"./smart-assets/edit-pen-source.svg": "a980",
	"./smart-assets/edit-pen.svg": "287c",
	"./smart-assets/facebook-icon.svg": "2ef6",
	"./smart-assets/fix-to-top.svg": "7bc3",
	"./smart-assets/font-icon.svg": "d7fd",
	"./smart-assets/google-sheets-icon.svg": "ce91",
	"./smart-assets/google-slides-icon.svg": "91b4",
	"./smart-assets/image-file-svg.svg": "194e",
	"./smart-assets/img-icon.svg": "7f04",
	"./smart-assets/instagram-icon.svg": "6d2a",
	"./smart-assets/line-height.svg": "6cce",
	"./smart-assets/list-unordered.svg": "2016",
	"./smart-assets/lock-position.svg": "c86c",
	"./smart-assets/log-out.svg": "aed7",
	"./smart-assets/minus.svg": "fd7c",
	"./smart-assets/network-browser.svg": "b164",
	"./smart-assets/paragraph-normal.svg": "dd58",
	"./smart-assets/paragraph-spacing.svg": "f446",
	"./smart-assets/picture-stack-landscape.svg": "ac68",
	"./smart-assets/playlist-editor.svg": "428d6",
	"./smart-assets/plus.svg": "53b1",
	"./smart-assets/qr-code-scan.svg": "a015",
	"./smart-assets/redo.svg": "a9b2",
	"./smart-assets/reorder-down.svg": "b6293",
	"./smart-assets/reorder-up.svg": "17fe",
	"./smart-assets/reset.svg": "0ca1",
	"./smart-assets/rss-icon.svg": "ab61",
	"./smart-assets/search.svg": "d34c",
	"./smart-assets/shape-icon.svg": "2e66",
	"./smart-assets/social-instagram.svg": "346a",
	"./smart-assets/text-icon.svg": "57cf",
	"./smart-assets/text-style.svg": "40b4",
	"./smart-assets/trash-bin.svg": "e039",
	"./smart-assets/undo.svg": "884c",
	"./smart-assets/video-player.svg": "f2ec",
	"./smart-assets/website-icon.svg": "465a",
	"./smart-assets/youtube-icon.svg": "6558",
	"./smart-assets/zap-dynamic.svg": "83fe",
	"./social-listview-icon.svg": "d449",
	"./social.svg": "9404",
	"./sort-down-white.svg": "0794",
	"./sort-up-white.svg": "57f0",
	"./sort-white-both.svg": "2dc5",
	"./term-active.svg": "198c",
	"./term.svg": "955d",
	"./time-down.svg": "d191",
	"./time-litsview.svg": "7689",
	"./time-up.svg": "1ea1",
	"./toolbar-bg-icon-active.svg": "bf0f",
	"./toolbar-bg-icon.svg": "876a",
	"./toolbar-edit-icon-active.svg": "5991",
	"./toolbar-edit-icon.svg": "c15e",
	"./toolbar-settings-icon-active.svg": "7001",
	"./toolbar-settings-icon.svg": "0216",
	"./toolbar-widget-icon-active.svg": "a944",
	"./toolbar-widget-icon.svg": "304a",
	"./trash bin.svg": "68bf",
	"./undo.svg": "ee2a",
	"./unlink.svg": "4d8c",
	"./user-icon.svg": "291e",
	"./user.svg": "c9d8",
	"./video-listview-icon.svg": "4be0",
	"./video-mini-icon.svg": "ad8c",
	"./video.svg": "b5ee",
	"./weather-list.svg": "2c61",
	"./weather-listview-icon.svg": "994e",
	"./web-active.svg": "74d3",
	"./web-grid.svg": "9e87",
	"./web-icon.svg": "48ff",
	"./web-icon1.svg": "df78",
	"./web-list.svg": "6559",
	"./web-listview-icon.svg": "190f",
	"./web.svg": "75f5",
	"./website-add.svg": "0d8e",
	"./wifi.svg": "2ed8",
	"./youtube-active.svg": "d148",
	"./youtube-icon.svg": "eb50",
	"./youtube-list.svg": "cea7",
	"./youtube-listview-icon.svg": "b037"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";